import { FetchRequest, FetchResponse } from '@rails/request.js'

interface Brand {
  address_line_1: null | string
  address_line_2: null | string
  city: null | string
  created_at: Date
  digital_lizard_username: string
  enabled: true
  id: string
  logo_id: null
  name: string
  phone: null | string
  primary_color_code: string
  ria_office_id: string
  secondary_color_code: string
  slug: string
  state: null | string
  stem_disclosure: null | string
  updated_at: Date
  website: null | string
  zip_code: null | string
}

interface FindBrandsArgs {
  id: string
}

interface FindBrandsResponse extends FetchResponse {
  get json(): Promise<Brand[]>
}

export function findBrands({ id }: FindBrandsArgs): Promise<FindBrandsResponse> {
  const endpoint = `/admin/ria_offices/${id}/find_brands`

  return new FetchRequest('get', endpoint).perform()
}
